import type { AnalysisLifecycleConfig } from '~/constants/types/projectDataVisualizations'

export function useAnalysisSelectionLifecycle(config: AnalysisLifecycleConfig) {
  const loadingStrataOptions = ref<boolean>(false)
  const lastFetchedKey = ref<string | undefined>(undefined)

  watch(
    () => toValue(config.analysisId),
    async (analysisID) => {
      if (!analysisID) {
        config.strataOptions.value = []
        return
      }

      loadingStrataOptions.value = true

      try {
        config.strataOptions.value = await config.getStrataOptions(analysisID)
      } finally {
        loadingStrataOptions.value = false
      }
    }
  )

  watch(
    () =>
      [
        toValue(config.analysisId),
        toValue(config.strataId),
        toValue(config.enabled) ?? true,
      ] as const,
    async ([analysisID, strataID, enabled], [oldAnalysisID]) => {
      if (!analysisID || !strataID || !enabled) {
        config.clearChartData?.(oldAnalysisID)

        lastFetchedKey.value = undefined
        return
      }

      const currentFetchKey = `${analysisID}-${strataID}`

      if (currentFetchKey === lastFetchedKey.value) {
        return
      }

      lastFetchedKey.value = currentFetchKey

      const success = await config.getChartData()

      if (!success) {
        lastFetchedKey.value = undefined
      }
    }
  )

  return {
    loadingStrataOptions,
  }
}
